import React from "react";

const InvoiceDetailsModal = ({ invoice, onClose }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 flex justify-center items-center z-50 p-2 sm:p-4 md:p-6"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full
          max-w-full sm:max-w-[90%] md:max-w-[70%] lg:max-w-[55%]
          max-h-[95vh] flex flex-col overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="bg-[#1F2937] px-4 py-3 sm:px-5 sm:py-4 flex items-center justify-between flex-shrink-0">
          <div className="min-w-0 mr-3">
            <p className="text-[10px] font-medium uppercase tracking-widest text-gray-400">
              Pharmacy Invoice
            </p>
            <p className="text-white font-semibold text-sm sm:text-base leading-tight mt-0.5">
              #{invoice.id}
            </p>
          </div>
          <button
            onClick={onClose}
            className="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-full
              bg-white/10 text-gray-300 hover:bg-white/20 hover:text-white
              transition-all duration-200 text-lg font-bold leading-none"
          >
            &times;
          </button>
        </div>

        {/* Info Strip */}
        <div className="bg-gray-50 border-b border-gray-100 px-4 py-2.5 sm:px-5 sm:py-3 flex items-center gap-2 sm:gap-3 flex-shrink-0">
          <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-gray-800 flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
            {invoice.customer_name?.charAt(0)?.toUpperCase() || "C"}
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-xs sm:text-sm font-semibold text-gray-800 truncate">
              {invoice.customer_name}
            </p>
            <p className="text-[11px] text-gray-400">
              {formatDate(invoice.date)}
            </p>
          </div>
          <span className="flex-shrink-0 text-[10px] sm:text-[11px] font-semibold px-2 py-0.5 sm:px-2.5 sm:py-1 rounded-full bg-blue-50 text-blue-600 border border-blue-100 whitespace-nowrap">
            {invoice.details?.length ?? 0} item(s)
          </span>
        </div>

        {/* Table */}
        <div className="overflow-y-auto overflow-x-auto flex-1 px-3 py-3 sm:px-5 sm:py-4">
          <table className="w-full min-w-[480px] text-xs sm:text-sm border-collapse">
            <thead>
              <tr className="bg-gray-50">
                {[
                  "#",
                  "Medicine",
                  "Qty",
                  "Unit Price",
                  "Discount",
                  "Discount Price",
                ].map((h) => (
                  <th
                    key={h}
                    className="text-[9px] sm:text-[10px] font-bold uppercase tracking-widest text-gray-400 px-3 py-2.5 text-left whitespace-nowrap"
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {invoice.details.map((item, index) => (
                <tr
                  key={index}
                  className="border-b border-gray-100 hover:bg-gray-50 transition-colors"
                >
                  <td className="px-3 py-2.5 text-gray-400 font-medium">
                    {index + 1}
                  </td>
                  <td className="px-3 py-2.5 text-gray-800 font-medium">
                    {item.medicine_name}
                  </td>
                  <td className="px-3 py-2.5 text-gray-600">{item.quantity}</td>
                  <td className="px-3 py-2.5 text-gray-600 whitespace-nowrap">
                    PKR {Number(item.sale_price).toLocaleString()}
                  </td>
                  <td className="px-3 py-2.5 text-gray-600 whitespace-nowrap">
                    PKR {Number(item.discount).toLocaleString()}
                  </td>
                  <td className="px-3 py-2.5 text-gray-800 font-semibold whitespace-nowrap">
                    PKR {Number(item.discount_price).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="bg-gray-50 border-t-2 border-gray-200">
                <td
                  colSpan="5"
                  className="px-3 py-2.5 text-[10px] font-bold uppercase tracking-widest text-gray-500"
                >
                  Total Amount
                </td>
                <td className="px-3 py-2.5 text-gray-800 font-bold whitespace-nowrap">
                  PKR {Number(invoice.amount).toLocaleString()}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default InvoiceDetailsModal;
